import React from "react"

import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent, Drawer, Grid, IconButton, Menu, MenuItem, TextField,
    Typography,
} from "@mui/material"

import {
    MatesMultilineTextField,
    MatesSelect,
    MatesTextField,
    withUseFormHook,
} from "@sinossi/mates-react-library"

import {
    t,
    Trans,
} from "@lingui/macro"
import { UseFormReturn } from "react-hook-form"

import NewTemplateValidation from "./form"
import {AssignableUsers, WorkflowObjectType} from "../../../../models";
import Icon from "@mdi/react";
import {mdiMenuClose, mdiMenuOpen} from "@mdi/js";
import {Placeholders} from "../../../commons/placeholders";
import {Autocomplete} from "@mui/lab";

interface OptionsType {
    id: string,
    name: string
}

interface NewTemplateProps extends UseFormReturn
{
    openDialog: boolean
    onClose: () => void
    submit: (values: any) => void
    users: AssignableUsers[]
}
interface NewTemplateState
{
    maxWidth: 'md' | 'lg'
    openPlaceholders: boolean
    timeout: any
    userValue: any
    userInputValue: string
    userOptions: OptionsType[]
}
class NewTemplate extends React.Component<NewTemplateProps, NewTemplateState>
{

    private typeOptions: {key: string, value: string}[] = [
        {key: "MATCH", value: "Match"},
        {key: "ASSET", value: "Immobile"},
        {key: "CONTRACT", value: "Contratto"},
        {key: "GENERIC", value: "Generico"}
    ]

    constructor(props: NewTemplateProps) {
        super(props);
        this.state = {
            maxWidth: 'md',
            openPlaceholders: false,
            userValue: null,
            userInputValue: "",
            userOptions: [],
            timeout: null
        }
    }

    componentDidMount() {
        this.props.watch((value, {name}) => this.closePlaceholders(value))
    }

    private submit = (values: any) => {
        this.props.submit(values)
    }

    private openPlaceholders = () => {
        if(this.props.getValues("templateType") !== ""){
            this.setState(() => ({
                openPlaceholders: true,
                maxWidth: 'lg'
            }))
        }
    }

    private closePlaceholders = (value?: any) => {
        if(value !== undefined){
            if(value.templateType === ""){
                this.setState(() => ({
                    openPlaceholders: false,
                    maxWidth: 'md'
                }))
            }
            return
        }
        this.setState(() => ({
            openPlaceholders: false,
            maxWidth: 'md'
        }))
    }

    private fetchUsers = (input: string) => {
        if(this.state.timeout){
            clearTimeout(this.state.timeout)
        }
        this.setState(() => ({
            timeout: setTimeout(() => this.filterUsers(input), 1000)
        }))
    }

    private filterUsers = (input: string) => {
        let newList: AssignableUsers[] = []

        this.props.users.map((user) => {
            let userName = (user.accountDetails.firstName ?? "") + (user.accountDetails.lastName ? " " + user.accountDetails.lastName : "") + " - " + user.username
            if (userName.includes(input)){
                newList.push(user)
            }
        })

        this.setUserOptions(newList)
    }

    private setUserOptions = (newList: AssignableUsers[]) => {
        let userOptions: OptionsType[] = []

        newList.map((user) => userOptions.push(
            {
                id: user.id,
                name: (user.accountDetails.firstName ?? "") + (user.accountDetails.lastName ? " " + user.accountDetails.lastName +  " - " : "") + user.username
            }
        ))

        this.setState(() => ({
            userOptions: userOptions
        }))
    }

    render()
    {
        let {userValue, userOptions} = this.state

        return (
            <Dialog open={this.props.openDialog} onClose={this.props.onClose} fullWidth maxWidth={this.state.maxWidth}>
                <Typography variant="h5" sx={{ml: 2, mt: 2}}>
                    <Trans id={'workflow.template.new-template.title'}>
                        Crea nuovo template
                    </Trans>
                </Typography>
                <Box sx={{margin: 2}}>
                    <form onSubmit={this.props.handleSubmit(this.submit)}>
                        <DialogContent>
                            <Grid container rowSpacing={3}>
                                <Grid item xs={this.state.openPlaceholders ? 5 : 11}>
                                    <MatesTextField
                                        variant={'outlined'}
                                        label={t({
                                            id: "workflow.template.new-template.name",
                                            message: "Nome",
                                        })}
                                        name="templateName"
                                        control={this.props.control}
                                        trigger={this.props.trigger}
                                        formState={this.props.formState}
                                        sx={{mb: 3}}
                                    />
                                    <MatesMultilineTextField
                                        variant={"outlined"}
                                        label={t({
                                            id: "workflow.template.new-template.description",
                                            message: "Descrizione",
                                        })}
                                        name="templateDescription"
                                        maxLength={254}
                                        control={this.props.control}
                                        trigger={this.props.trigger}
                                        formState={this.props.formState}
                                        sx={{mb: 3}}
                                    />
                                    <MatesSelect
                                        variant={"outlined"}
                                        label={t({
                                            id: "workflow.template.new-template.type",
                                            message: "Tipo",
                                        })}
                                        name="templateType"
                                        control={this.props.control}
                                        trigger={this.props.trigger}
                                        formState={this.props.formState}
                                        sx={{mb: 3}}>
                                        {this.typeOptions.map((option) => (
                                            <option value={option.key} key={option.key}>{option.value}</option>))
                                        }
                                    </MatesSelect>
                                    <Autocomplete
                                        getOptionLabel={(option) => option.name}
                                        filterOptions={(x) => x}
                                        options={userOptions}
                                        autoComplete
                                        includeInputInList
                                        filterSelectedOptions
                                        value={userValue}
                                        noOptionsText={t({id: "create-contract-modal.no-user", message: "Inizia a digitare per avviare la ricerca"})}
                                        onChange={(event, newValue) => {
                                            if (newValue) {
                                                this.setState(() => ({
                                                    userValue: newValue, userOptions: [newValue, ...userOptions]
                                                }));
                                                this.props.setValue("templateAssignTo", newValue.id)
                                            }
                                        }}
                                        onInputChange={(event, newInputValue) => {
                                            this.setState({ userInputValue: newInputValue }, () => {
                                                if (this.state.userInputValue === '') {
                                                    this.setState({ userOptions: userValue ? [userValue] : [] });
                                                }
                                                else {
                                                    this.fetchUsers(this.state.userInputValue)
                                                }
                                            })
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params}
                                                       label={t({id: "create-contract-modal.select-user", message: "Assegna a..."})}
                                                       fullWidth
                                                       required
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={1} textAlign={"right"}>
                                    <IconButton
                                        aria-controls="menu"
                                        aria-haspopup="true"
                                        onClick={this.state.openPlaceholders ? () => this.closePlaceholders() : () => this.openPlaceholders()}
                                        color="inherit"
                                    >
                                        {
                                            this.state.openPlaceholders &&
                                            <Icon path={mdiMenuOpen} size={1}/>
                                        }
                                        {
                                            !this.state.openPlaceholders &&
                                            <Icon path={mdiMenuClose} size={1}/>
                                        }
                                    </IconButton>
                                </Grid>
                                {
                                    this.state.openPlaceholders && this.props.getValues("templateType") !== "" &&
                                    <Placeholders templateType={this.props.getValues("templateType")} template/>
                                }
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.props.onClose}
                                    variant={"contained"}
                                    color="neutral"
                                    sx={{
                                        textTransform: "none",
                                        mr: 1,
                                        width: 100
                                    }}
                                    disableElevation>
                                <Trans id={"workflow.template.new-template.abort"}>
                                    Annulla
                                </Trans>
                            </Button>
                            <Button type="submit"
                                    variant="contained"
                                    sx={{
                                        backgroundColor: 'secondary.main',
                                        color: 'white',
                                        mr: 1,
                                        textTransform: "none",
                                        width: 100
                                    }}
                            >
                                <Trans id={"workflow.template.new-template.save"}>
                                    Salva
                                </Trans>
                            </Button>
                        </DialogActions>
                    </form>
                </Box>
            </Dialog>
        )
    }
}

export default withUseFormHook<{}>(
    NewTemplate,
    NewTemplateValidation,
    {}
)
